module.exports = __webpack_public_path__ + "img/sheba.a8ef0b17.png";